"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactTransitionGroup = require("react-transition-group");
require("./Prompt.less");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @TODO: portal to document root on mobile so overlay can sit above header as well
var Prompt = function Prompt(_ref) {
  var visible = _ref.visible,
    onClose = _ref.onClose,
    onExited = _ref.onExited,
    children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    in: !!visible,
    timeout: 300,
    classNames: "cubby-prompt",
    onExited: onExited,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cubby-prompt"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cubby-prompt-overlay",
    onClick: onClose
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('cubby-prompt-content', className)
  }, children)));
};
var _default = Prompt;
exports.default = _default;